import {
  arrayJsonFormat,
  base64StringJsonFormat,
  booleanJsonFormat,
  objectJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import * as z from "zod";

// Inlined to keep this leaf free of any redo/model dependency.
const attributableDiscountCodesSchema = z.array(z.string()).nullish();
const attributableGiftCardIdsSchema = z.array(z.string()).nullish();
const giftCardIdsRemindedAboutSchema = z.array(z.string()).nullish();

// Raw schema exported (in addition to the annotated one below) for consumers
// that need ZodObject methods like `.pick`.
export const smsMessageMetadataSchema_ = z.object({
  teamId: z.string(),
  phoneNumber: z.string(),
  campaignId: z.string().optional(),
  automationId: z.string().optional(),
  automationStepId: z.string().optional(),
  templateId: z.string().optional(),
  category: z.string().optional(),
  isTest: z.boolean().optional(),
  recipientId: z.string().optional(),
  aiGenerated: z.boolean().optional(),
  marketingMessageId: z.string().optional(),
  discountCodes: attributableDiscountCodesSchema,
  giftCardIds: attributableGiftCardIdsSchema,
  giftCardIdsRemindedAbout: giftCardIdsRemindedAboutSchema,
});
export const smsMessageMetadataSchema: z.ZodType<SmsMessageMetadata> =
  smsMessageMetadataSchema_;
export interface SmsMessageMetadata extends z.infer<
  typeof smsMessageMetadataSchema_
> {}

const _metadataFormat = objectJsonFormat<SmsMessageMetadata>(
  { teamId: stringJsonFormat, phoneNumber: stringJsonFormat },
  {
    campaignId: stringJsonFormat,
    automationId: stringJsonFormat,
    automationStepId: stringJsonFormat,
    templateId: stringJsonFormat,
    category: stringJsonFormat,
    recipientId: stringJsonFormat,
    isTest: booleanJsonFormat,
    aiGenerated: booleanJsonFormat,
    marketingMessageId: stringJsonFormat,
    discountCodes: arrayJsonFormat(stringJsonFormat),
    giftCardIds: arrayJsonFormat(stringJsonFormat),
    giftCardIdsRemindedAbout: arrayJsonFormat(stringJsonFormat),
  },
);

export const metadataFormat = base64StringJsonFormat(_metadataFormat);
